import { LOCALE_CHANGED, SERVER_PROFILES_CHANGED, PROCESS_CHANGED } from '../constants'

export function localeChanged(locale) {
    return {
        type: LOCALE_CHANGED,
        payload: locale,
    }
}

export function serverProfilesChanged(serverId, profiles) {
    return {
        type: SERVER_PROFILES_CHANGED,
        payload: { serverId, profiles },
    }
}

export function processChanged(changes) {
    return {
        type: PROCESS_CHANGED,
        payload: changes,
    }
}



// WEBPACK FOOTER //
// ./src/actions/feature.js